module.exports = __webpack_public_path__ + "static/media/how-step3.14303e33.svg";